import React, { useEffect } from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import Translation from '@swf/components/Translation/Translation';
import usePrevious from '@swf/core/hooks/usePrevious';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import { useIsMobileDevice } from '@swf/poker';

import Banner from '../../Modal/Banner/Banner';
import { ModalPagesRoutes } from '../utils/common';

import { TXTCLI_Tournament, TXTMOB_Create } from './CreateTournamentBanner.messages.json';
import styles from './CreateTournamentBanner.scss';

const Title = () => (
  <>
    <Translation {...TXTMOB_Create} />
    <br />
    <Translation {...TXTCLI_Tournament} />
  </>
);

const CreateTournamentBanner = () => {
  const isMobileDevice = useIsMobileDevice(true);
  const prevIsMobileDevice = usePrevious(isMobileDevice);
  const { jumpForward } = useWizardJump();

  useEffect(() => {
    // Scrolling from mobile to desktop
    if (!isMobileDevice && prevIsMobileDevice) {
      jumpForward(ModalPagesRoutes[ModalPagesRoutes['#create-tournament-flow.main-info']]);
    }
  }, [isMobileDevice, jumpForward, prevIsMobileDevice]);

  return isMobileDevice ? (
    <StarsWizard.Page name="CreateTournamentBanner">
      <Banner title={<Title />} className={styles.bannerBg} />
    </StarsWizard.Page>
  ) : (
    <Banner title={<Title />} className={styles.bannerBg} />
  );
};

CreateTournamentBanner.displayName = 'CreateTournamentBanner';

export default CreateTournamentBanner;
